import { render } from "./ProductDetail_RiskCompliance.vue?vue&type=template&id=37455710&scoped=true"
import script from "./ProductDetail_RiskCompliance.vue?vue&type=script&lang=js"
export * from "./ProductDetail_RiskCompliance.vue?vue&type=script&lang=js"

import "./ProductDetail_RiskCompliance.vue?vue&type=style&index=0&id=37455710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37455710"]])

export default __exports__